<template>
    <div :class="{'uk-editable': editable&&!empty}" class="lam-attachment-image">
        <div class="lam-dropzone">
            <file-upload-form
                v-if="editable"
                :value="!!attachment_record ? attachment_record.shareable_url : ''"
                :accepts="upload_accepts(name)"
                :show-upload-icon="false"
                :copy-pastable="copyPastable"
                :uploading="!!uploading[name]"
                :uploaded="uploaded[name]||0"
                :editable="editable"
                @upload="upload_file_list(name, $event)"
            >
                <small slot="message-drag-or-click">
                    <img v-if="!empty" :src="attachment_record.shareable_url" />
                    <div v-else>
                        <open-icon glyph="image" size="large" class="uk-text-muted uk-margin-small-bottom" />
                        <br />Click to upload your image, or drag and drop it, or copy-paste it...
                    </div>
                </small>
                <template v-slot:empty><em>(No image uploaded)</em></template>
            </file-upload-form>
        </div>
        <a v-if="editable&&!empty" href class="uk-icon-button uk-icon-close" title="Delete" @click.prevent="confirm_clear_file(name)"></a>
    </div>
    <!--
    <div :class="{'uk-editable': editable&&!empty}" class="lam-attachment-image">
        <div class="lam-dropzone">
            <file-upload-form v-if="editable" :entity="entity" task="attach" name="attachment" :entity-id="record.id" :show-upload-icon="false" :submit-data="{ type: 'image' }" :copy-pastable="true" accepted-types=".jpg,.jpeg,.png" @success="uploaded">
                <div slot="message-drag-or-click">
                    <img v-if="!empty" :src="record.image.shareable_url" />
                    <div v-else>
                        <open-icon glyph="image" size="large" class="uk-text-muted uk-margin-small-bottom" />
                        <br />Click to upload your image, or drag and drop it, or copy-paste it...
                    </div>
                </div>
            </file-upload-form>
            <img v-else-if="!empty" :src="record.image.shareable_url" />
            <div v-else class="uk-text-center"><em>(No image uploaded)</em></div>
        </div>
        <a v-if="editable&&!empty" href class="uk-icon-button uk-icon-close" title="Delete" @click.prevent="detach"></a>
    </div>
    //-->
</template>

<script type="text/javascript">
import handles_uploads from "../mixins/HandlesUploads"

import FileUploadForm from "./FileUploadForm"
import OpenIcon from "../ui/OpenIcon"

export default {
    mixins: [handles_uploads],
    components: {
        FileUploadForm,
        OpenIcon
    },
    methods: {
        upload_accepts (name, filename = null) {
            if(filename) return !!filename.match(/\.(png|jpe?g)$/i)
            return "image/jpeg,image/png,.jpg,.jpeg,.png"
        },
        upload_data (name) {
            return { entity: this.entity, id: this.ownerId, type: "image" }
        },
        upload_attach_error (name, error) {
            this.$error(error.message)
        },
        upload_attached (name, response) {
            if(!!response && !!response.data && !!response.data.success) this.$success(response.data.success)
        },
        upload_detached () {
            const attachment = this.attachment_record
            if(attachment) this.$store.dispatch("DUSTING", { entity: "attachment", record_id: attachment.id })
        }
    },
    computed: {
        attachment_record () {
            if(!this.ownerId) return null
            return this.raw_attachment_records.find(attachment => (attachment.owner_type === this.ownerType) && (attachment.owner_id === this.ownerId))
        },
        empty () {
            return !this.attachment_record || !this.attachment_record.shareable_url
        }
    },
    props: {
        name: {
            type: String,
            default: "attachment"
        },
        entity: {
            type: String,
            required: true
        },
        ownerType: {
            type: String,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        accepts: {
            type: String,
            default: ""
        },
        acceptsExtensions: {
            type: Object,
            default: null
        },
        copyPastable: {
            type: Boolean,
            default: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
